/* import __COLOCATED_TEMPLATE__ from './index.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
/* eslint-disable ember/no-runloop */
import ApplicationInstance from "@ember/application/instance";
import { action } from "@ember/object";
import { getOwner } from "@ember/owner";
import { next } from "@ember/runloop";
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import JournalEventModel from "core/models/journal-event";
import { modifier } from "ember-modifier";
import JesHistoryTableComponent from "..";
let JesHistoryTableColumnComponent = (_class = class JesHistoryTableColumnComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "labelElement", _descriptor, this);
    _initializerDefineProperty(this, "values", _descriptor2, this);
    _initializerDefineProperty(this, "edits", _descriptor3, this);
    _defineProperty(this, "addValue", modifier(this._addValue));
    _defineProperty(this, "addEdit", modifier(this._addEdit));
    _defineProperty(this, "setLabelElement", modifier(this._setLabelElement));
    this.args.onInit(this);
  }
  get patient() {
    return this.args.table.patient;
  }
  get propertyName() {
    return this.args.propertyName;
  }
  get fullComponentId() {
    return Boolean(this.args.feature) && Boolean(this.args.component) ? `${this.args.feature}/${this.args.component}` : "";
  }
  get jeClass() {
    return this.args.jeClass || getOwner(this).factoryFor(`model:${this.args.modelName}`)?.class;
  }
  get patientRelationName() {
    // Transform `weight-measured-journal-event` to `weightMeasuredJournalEvents`
    return `${this.args.modelName.replace(/-./g, m => m[1].toUpperCase())}s`;
  }
  get disableTimePopup() {
    return this.args.disableTimePopup;
  }
  _addValue(element, [value]) {
    next(() => {
      this.values.push({
        element,
        value
      });
      // eslint-disable-next-line no-self-assign
      this.values = this.values; // self assign to keep reactivity
    });
  }
  _addEdit(element, [je]) {
    next(() => {
      this.edits.push({
        element,
        je
      });
      // eslint-disable-next-line no-self-assign
      this.edits = this.edits; // self assign to keep reactivity
    });
  }
  _setLabelElement(el) {
    this.labelElement = el;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "labelElement", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "values", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "edits", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "_addValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_addValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_addEdit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_addEdit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_setLabelElement", [action], Object.getOwnPropertyDescriptor(_class.prototype, "_setLabelElement"), _class.prototype), _class);
export { JesHistoryTableColumnComponent as default };